import { purchaseStatusRank } from "./poBoardStatusLanes";
import {
  canDropOnCombinedColumn,
  groupShipmentsByCombinedLanes,
  resolveCombinedPlacementColumn,
} from "../../shipment/constants/shipmentCombinedBoard.js";

export const PURCHASE_COMBINED_BOARD_SHOW_EMPTY_LANES_KEY =
  "purchaseCombinedBoardShowEmptyLanes";

/**
 * @param {Object} order
 * @param {Array<Object>} columns
 * @return {Object|null}
 */
export function resolvePurchaseCombinedPlacement(order, columns) {
  return resolveCombinedPlacementColumn(order, columns, purchaseStatusRank);
}

/**
 * @param {Object} order
 * @param {Object} targetColumn
 * @param {Array<Object>} columns
 * @return {boolean}
 */
export function canDropOnPurchaseCombinedColumn(order, targetColumn, columns) {
  return canDropOnCombinedColumn(order, targetColumn, columns, purchaseStatusRank);
}

/**
 * @param {Array<Object>} orders
 * @param {Array<Object>} columns
 * @return {Record<string, Array<Object>>}
 */
export function groupPurchaseOrdersByCombinedLanes(orders = [], columns = []) {
  return groupShipmentsByCombinedLanes(orders, columns, purchaseStatusRank);
}

/**
 * @return {boolean}
 */
export function readPurchaseCombinedBoardShowEmptyLanes() {
  try {
    const raw = localStorage.getItem(PURCHASE_COMBINED_BOARD_SHOW_EMPTY_LANES_KEY);
    if (raw === null) {
      return true;
    }
    return raw !== "false";
  } catch (_) {
    return true;
  }
}

/**
 * @param {boolean} showEmptyLanes
 * @return {void}
 */
export function writePurchaseCombinedBoardShowEmptyLanes(showEmptyLanes) {
  try {
    localStorage.setItem(
      PURCHASE_COMBINED_BOARD_SHOW_EMPTY_LANES_KEY,
      showEmptyLanes ? "true" : "false",
    );
  } catch (_) {
    /* ignore */
  }
}

export const PURCHASE_BOARD_HIDE_EMPTY_LANES_MODE_KEY =
  "purchaseBoardHideEmptyLanesMode";

const VALID_HIDE_EMPTY_LANES_MODES = new Set(["none", "status", "milestone", "all"]);

/**
 * @return {import("../../shipment/constants/shipmentCombinedBoard.js").HideEmptyLanesMode}
 */
export function readPurchaseBoardHideEmptyLanesMode() {
  try {
    const raw = localStorage.getItem(PURCHASE_BOARD_HIDE_EMPTY_LANES_MODE_KEY);
    if (raw && VALID_HIDE_EMPTY_LANES_MODES.has(raw)) {
      return /** @type {import("../../shipment/constants/shipmentCombinedBoard.js").HideEmptyLanesMode} */ (
        raw
      );
    }
    if (readPurchaseCombinedBoardShowEmptyLanes() === false) {
      return "all";
    }
    return "none";
  } catch (_) {
    return "none";
  }
}

/**
 * @param {import("../../shipment/constants/shipmentCombinedBoard.js").HideEmptyLanesMode} mode
 * @return {void}
 */
export function writePurchaseBoardHideEmptyLanesMode(mode) {
  if (!VALID_HIDE_EMPTY_LANES_MODES.has(mode)) {
    return;
  }
  try {
    localStorage.setItem(PURCHASE_BOARD_HIDE_EMPTY_LANES_MODE_KEY, mode);
  } catch (_) {
    /* ignore */
  }
}
